// extracted by mini-css-extract-plugin
export var formContainer = "_in-0";
export var message = "_in-1";